import * as React from "react";
import type { SVGProps } from "react";

interface StartOvertimeProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const StartOvertime = ({ cancelled = false, ...props }: StartOvertimeProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.25 2.25)">
        <circle
          cx={7.5}
          cy={7.5}
          r={8.57}
          fill="#60B100"
          stroke="#FFF"
          strokeWidth={2.15}
        />
        <circle cx={7.5} cy={7.5} r={8.15} stroke="#000" strokeWidth={1.3} />
      </g>
      <path
        fill="#FFF"
        stroke="#000"
        strokeWidth={1.1}
        d="m7.5 4.3 7.35 5.05a.42.42 0 0 1 0 .69L7.5 15.08a.42.42 0 0 1-.66-.34V4.65a.42.42 0 0 1 .66-.35Z"
      />
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M6.82 18.71c-.8.66-.93 1.84-.28 2.65l.59.72c.55.69 1.51.9 2.3.5l3.97-1.97.14.15a5.37 5.37 0 0 0 7.1.64l.17-.14a5.35 5.35 0 0 0 1.82-5.43l-.01-.07.05-.04c.57-.64.64-1.6.14-2.33l-.08-.11a1.88 1.88 0 0 0-2.15-.58l-.04.02a5.36 5.36 0 0 0-6.34.02l-.18.14a1.6 1.6 0 0 0-.5 1.75l.02.07-1.03.84a1.66 1.66 0 0 0-1.81.04l-.12.08z"
        />
        <path
          fill="#000"
          d="M7.2 19.18a1.28 1.28 0 0 0-.2 1.8l.6.73c.37.46 1.02.6 1.56.34l4.2-2.1a.28.28 0 0 1 .35.09l.02.02a4.76 4.76 0 0 0 8.23-4.44l-.03-.07.02-.01.13-.09c.54-.44.62-1.25.18-1.8a1.28 1.28 0 0 0-1.8-.2h.03l-.06-.06a4.77 4.77 0 0 0-5.85-.18l-.18.13a1 1 0 0 0-.15 1.41l.04.05c.02.02.02.06 0 .08l-1.76 1.41a.06.06 0 0 1-.08 0 1.06 1.06 0 0 0-1.49-.16zm.63.78 3.76-3.05a.06.06 0 0 1 .08 0c.37.46 1.04.53 1.5.16l1.74-1.41c.46-.37.53-1.04.16-1.5l-.04-.04.16-.12a3.77 3.77 0 0 1 4.84.38l.14.14a.5.5 0 0 0 .84-.17.26.26 0 0 1 .08-.11c.12-.1.3-.08.4.04s.07.3-.04.4a.26.26 0 0 1-.18.05.5.5 0 0 0-.46.72 3.76 3.76 0 0 1-1 4.57 3.77 3.77 0 0 1-5.3-.59l-.02-.01a1.28 1.28 0 0 0-1.58-.36l-4.2 2.1a.28.28 0 0 1-.34-.08l-.59-.73a.28.28 0 0 1 .05-.4Z"
        />
        <path
          fill="#000"
          d="M15.95 15.23c-.99.82-1.14 2.3-.33 3.3a2.3 2.3 0 0 0 3.25.35c1-.81 1.15-2.29.34-3.3a2.3 2.3 0 0 0-3.26-.35m.64.78a1.3 1.3 0 0 1 1.84.2c.47.58.38 1.43-.19 1.9a1.3 1.3 0 0 1-1.84-.2 1.36 1.36 0 0 1 .19-1.9"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M20.15 0c.77 0 1.4.63 1.4 1.4v1.1h1.1c.73 0 1.33.56 1.4 1.27v.13c0 .77-.63 1.4-1.4 1.4h-1.1v1.1a1.4 1.4 0 0 1-1.27 1.4h-.13a1.4 1.4 0 0 1-1.4-1.4V5.3h-1.1a1.4 1.4 0 0 1-1.4-1.27V3.9c0-.77.63-1.4 1.4-1.4h1.1V1.4c0-.73.56-1.33 1.27-1.4z"
        />
        <path
          fill="#000"
          d="M20.15.75c.36 0 .65.3.65.65v1.85h1.85a.65.65 0 1 1 0 1.3H20.8V6.4a.65.65 0 1 1-1.3 0V4.55h-1.85a.65.65 0 1 1 0-1.3h1.85V1.4c0-.36.3-.65.65-.65"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default StartOvertime;
